const OrderSummary = (props) => {
  const {
    isDesktop, order, convertCentsToDollars, shippingTotal,
  } = props;
  const orderSubtotal = convertCentsToDollars(order.totalPrice.centAmount);
  const orderAmount = convertCentsToDollars(
    order.taxedPrice.totalGross.centAmount,
  );
  const orderTax = convertCentsToDollars(
    order.taxedPrice.totalGross.centAmount -
      order.taxedPrice.totalNet.centAmount,
  );
  return (
    <div className="order-summary">
      <div className="ff-graphik">
        <div className="summary-header">
          <h3 className="ff-wallop c-purple-primary order-summary-heading">
            Order Summary
          </h3>
        </div>
        <div className={!isDesktop ? 'd-flex flex-column' : ''}>
          <div className="alternative m-auto order-summary-info">
            <div className="d-flex justify-content-between align-items-center m-b-8">
              <p className="no-margin ff-graphik c-purple fs-14 fw-medium">
                Price
                {' '}
                {order.lineItems.length > 1 && (`(${order.lineItems.length} items)`)}
                {order.lineItems.length === 1 && (`(${order.lineItems.length} item)`)}
              </p>
              <p className="no-margin ff-graphik fw-normal c-purple fs-14">
                $
                {orderSubtotal}
              </p>
            </div>
            <div className="d-flex justify-content-between align-items-center c-purple m-b-8">
              <p className="no-margin c-purple fs-14 fw-medium">Shipping</p>
              {shippingTotal > 0 ? (
                <p className="no-margin fs-14 fw-normal">
                  $
                  {convertCentsToDollars(shippingTotal)}
                </p>
              ) : 'Free'}
            </div>
            <div className="d-flex justify-content-between align-items-center m-b-8">
              <p className="no-margin c-purple fs-14 fw-medium">Taxes</p>
              <p className="no-margin c-purple fs-14 fw-normal">
                $
                {orderTax}
              </p>
            </div>
          </div>
          <div slot="summary-footer">
            <div className="d-flex justify-content-between align-items-center fw-medium">
              <h4 className="order-summary-footer-label ff-graphik fw-medium fs-16 order-label c-purple">
                Order Total
              </h4>
              <h4 className="order-summary-footer-label ff-graphik fw-medium fs-16 order-label c-purple" data-testid="order-amount">
                $
                {orderAmount}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
